import React from "react";
import { createRoot } from "reactdom";
import SiteSearch404 from "../components/SiteSearch404";

const renderSiteSearch = () => {

	const searchBarElements = document.getElementsByClassName("js-search-bar");
	
	if (searchBarElements) {
		Array.from(searchBarElements).forEach(function (searchbar) {
			const root = createRoot(searchbar);
			let props = {
				...(searchbar && searchbar.dataset),
			};
			root.render(<SiteSearch404 {...props} />);
		});
	}
};

export default renderSiteSearch;
